import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { PLATFORM_ACCENTS } from '@/lib/format';
import { platformLogo } from '@/lib/logos';

export function PlatformCard({ platform, showRecharge = true }) {
    const accent = PLATFORM_ACCENTS[platform.key] || PLATFORM_ACCENTS.olaparty;
    return (
        <Card
            className="relative overflow-hidden bg-card border-border rounded-2xl p-5 shadow-card hover:shadow-soft transition-shadow flex flex-col"
            data-testid={`platform-card-${platform.key}`}
        >
            <span
                aria-hidden
                className="absolute left-0 top-0 h-full w-1"
                style={{ background: accent.color }}
            />
            <div className="flex items-start justify-between">
                <div>
                    {platformLogo(platform.key) ? (
                        <img
                            src={platformLogo(platform.key)}
                            alt={platform.name}
                            className="h-12 w-12 rounded-xl object-cover"
                            style={{ border: `1px solid ${accent.border}` }}
                        />
                    ) : (
                        <div
                            className="inline-flex h-12 w-12 rounded-xl items-center justify-center font-display font-semibold text-lg"
                            style={{ background: accent.bg, color: accent.color, border: `1px solid ${accent.border}` }}
                        >
                            {platform.name.charAt(0)}
                        </div>
                    )}
                    <div className="mt-3">
                        <div className="text-base font-semibold font-display text-foreground">{platform.name}</div>
                        <div className="text-xs text-muted-foreground">{platform.tagline}</div>
                    </div>
                </div>
                <div
                    className="text-[10px] font-medium px-2 py-1 rounded-md uppercase tracking-wider"
                    style={{ background: accent.bg, color: accent.color }}
                >
                    {platform.unit}
                </div>
            </div>
            <p className="text-sm text-muted-foreground mt-3 line-clamp-3">{platform.description}</p>
            <ul className="mt-3 space-y-1.5">
                {(platform.highlights || []).slice(0, 3).map((h, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-foreground/80">
                        <Check className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" style={{ color: accent.color }} />
                        <span>{h}</span>
                    </li>
                ))}
            </ul>
            <div className="flex-1" />
            <div className="mt-5 flex items-center gap-2">
                <Button
                    asChild
                    className="flex-1 bg-[#0E2A47] hover:bg-[#0B223A] text-white"
                    data-testid={`platform-join-now-button-${platform.key}`}
                >
                    <Link to={`/register`}>Join Now <ArrowRight className="h-4 w-4 ml-1" /></Link>
                </Button>
                {showRecharge && (
                    <Button asChild variant="outline" data-testid={`platform-view-plans-button-${platform.key}`}>
                        <Link to={`/platforms/${platform.key}`}>Plans</Link>
                    </Button>
                )}
            </div>
        </Card>
    );
}
